// extracted by mini-css-extract-plugin
export default {"header":"Header_header__Ur9x3","content":"Header_content__SvvkR"};